import { render, staticRenderFns } from "./DevisDataTable.vue?vue&type=template&id=3ee64e26"
import script from "./DevisDataTable.vue?vue&type=script&lang=js"
export * from "./DevisDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports